import { useTranslation } from 'react-i18next'

type Investigator = {
  id: string | number
  username?: string | null
  displayName?: string | null
  avatarUrl?: string | null
  biography?: string | null
}

/**
 * Single investigator card: avatar (or fallback logo), display name with
 * optional `@username`, and an optional truncated bio.
 */
export function InvestigatorCard({ inv }: { inv: Investigator }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center text-center gap-3 p-5 rounded-xl border border-border bg-background hover:border-primary/40 hover:shadow-md hover:shadow-primary/5 transition-all duration-200">
      {/* Avatar */}
      <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-border bg-muted shrink-0">
        {inv.avatarUrl ? (
          <img
            src={inv.avatarUrl}
            alt={inv.displayName ?? inv.username ?? ''}
            className="w-full h-full object-cover"
          />
        ) : (
          <img
            src="/logo.png"
            alt="Balivernologie"
            className="w-full h-full object-contain p-2 opacity-60"
          />
        )}
      </div>

      {/* Name */}
      <div>
        <p className="font-semibold text-sm text-foreground">
          {inv.displayName ?? inv.username ?? t('investigators.unknown')}
        </p>
        {inv.displayName && inv.username && (
          <p className="text-xs text-muted-foreground">@{inv.username}</p>
        )}
      </div>

      {/* Bio */}
      {inv.biography && (
        <p className="text-xs text-muted-foreground leading-relaxed line-clamp-3">
          {inv.biography}
        </p>
      )}
    </div>
  )
}
